import { useDataMutation } from '@packages/dataQuery';
import { postDetailData } from '../api';
import { CustomObject } from '../../../../types';
import { ContactUsFormValues, PostIssueDetailResponseData } from '../types';

export function usePostIssueDetailMutation() {
	return useDataMutation<PostIssueDetailResponseData, CustomObject, ContactUsFormValues>(postDetailData);
}
